import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { WwwRouteSlug } from '../../models';
import { Angulartics2GoogleTagManager } from 'angulartics2';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, NgOptimizedImage],
})
export class FooterComponent {
  protected readonly WwwRouteSlug = WwwRouteSlug;
  private readonly _angulartics2GoogleTagManager = inject(Angulartics2GoogleTagManager);

  public pushLayer(eventLabel: string, clickArea: string): void {
    this._angulartics2GoogleTagManager.pushLayer({
      event: 'uaevent',
      ecommerce: 'undefined',
      eventCategory: 'main menu navigation',
      eventAction: 'select::footer',
      eventLabel: eventLabel,
      event_name: 'menu_click',
      click_area: clickArea,
      breadcrumb: eventLabel,
    });
  }
}
